import React, { useEffect } from 'react'
import { useParams } from 'react-router-dom'
import { pageTitle } from '../../helper'
import Accordion from '../Accordion'
import Button from '../Button'
import Cta from '../Cta'
import IconBox from '../IconBox'
import PageHeading from '../PageHeading'
import Div from '../Div'
import SectionHeading from '../SectionHeading'
import TestimonialSlider from '../Slider/TestimonialSlider'
import Spacing from '../Spacing'

export default function ServiceDetailsPage() {
  pageTitle('VR Development');
  const params = useParams();
  useEffect(() => {
    window.scrollTo(0, 0)
  }, [])

  return (
    <>
      <PageHeading
        title='VR Development'
        bgSrc='/images/service_hero_bg.jpeg'
        pageLinkText={'VR Development'}
      />

      <Spacing lg='145' md='80' />

      {/* Introduction Section */}
      <Div className="container">
        <SectionHeading
          title='Immersive Virtual Reality Solutions'
          subtitle='Step Into the Future with Fully Immersive VR Experiences'
          variant='cs-style1 text-center'
        />
        <Spacing lg='30' md='20' />
        <p className='cs-text_large text-center'>
          At Dappster Studio, we create captivating Virtual Reality (VR) applications that transport users into fully interactive 3D environments. Whether it’s for training, simulation, entertainment, or marketing, our VR development services push the boundaries of digital engagement.
        </p>
        <Spacing lg='20' md='15' />
        <p className='cs-text_large text-center'>
          Leveraging industry-leading platforms like Unity, Unreal Engine, Oculus SDK, and SteamVR, we build VR experiences compatible with headsets like Oculus Quest, HTC Vive, and Valve Index. Our solutions are tailored to your objectives—whether it's realism, storytelling, or real-time simulation.
        </p>
      </Div>

      <Spacing lg='120' md='60' />

      {/* Services Section */}
      <Div className="container">
        <SectionHeading
          title='Our Virtual Reality Services'
          subtitle='Custom VR Experiences for Every Use Case'
          variant='cs-style1 text-center'
        />
        <Spacing lg='90' md='45' />
        <Div className="row">
          <Div className="col-lg-4">
            <IconBox
              icon='/images/icons/service_icon_1.svg'
              title='VR App Development'
              subtitle='Cross-platform VR applications using Unity, Unreal Engine, and WebXR.'
            />
            <Spacing lg='30' md='30' />
          </Div>
          <Div className="col-lg-4">
            <IconBox
              icon='/images/icons/service_icon_2.svg'
              title='Training & Simulation'
              subtitle='Realistic simulations for corporate training, education, military, and healthcare.'
            />
            <Spacing lg='30' md='30' />
          </Div>
          <Div className="col-lg-4">
            <IconBox
              icon='/images/icons/service_icon_3.svg'
              title='VR Gaming Experiences'
              subtitle='Immersive games with motion tracking, spatial audio, and engaging storylines.'
            />
            <Spacing lg='30' md='30' />
          </Div>
          <Div className="col-lg-4">
            <IconBox
              icon='/images/icons/service_icon_4.svg'
              title='360° Virtual Tours'
              subtitle='Interactive tours for real estate, tourism, education, and event venues.'
            />
            <Spacing lg='30' md='30' />
          </Div>
          <Div className="col-lg-4">
            <IconBox
              icon='/images/icons/service_icon_5.svg'
              title='Enterprise VR Solutions'
              subtitle='Custom VR platforms for remote collaboration, product design, and prototyping.'
            />
            <Spacing lg='30' md='30' />
          </Div>
          <Div className="col-lg-4">
            <IconBox
              icon='/images/icons/service_icon_6.svg'
              title='VR Content Creation'
              subtitle='Photorealistic 3D modeling, animations, and storytelling for immersive experiences.'
            />
            <Spacing lg='30' md='30' />
          </Div>
        </Div>
      </Div>

      <Spacing lg='120' md='60' />

      {/* Industries Section */}
      <Div className="container">
        <SectionHeading
          title='Industries Using VR'
          subtitle='Transforming Realities Across Diverse Sectors'
          variant='cs-style1 text-center'
        />
        <Spacing lg='30' md='20' />
        <Div className="row">
          <Div className="col-lg-4">
            <IconBox
              icon='/images/icons/healthcare-icon.svg'
              title='Healthcare'
              subtitle='VR therapy, surgical simulations, and patient education in virtual environments.'
            />
          </Div>
          <Div className="col-lg-4">
            <IconBox
              icon='/images/icons/education-icon.svg'
              title='Education & Training'
              subtitle='Immersive learning with interactive lessons, virtual classrooms, and safety training.'
            />
          </Div>
          <Div className="col-lg-4">
            <IconBox
              icon='/images/icons/house-icon.svg'
              title='Real Estate'
              subtitle='Virtual property walkthroughs for enhanced buyer engagement and decision-making.'
            />
          </Div>
        </Div>
        <Div className="row mt-lg-5" >
          <Div className="col-lg-6">
            <IconBox
              icon='/images/icons/game-icon.svg'
              title='Gaming & Entertainment'
              subtitle='Next-level gameplay and experiences through virtual reality interaction.'
            />
          </Div>
          <Div className="col-lg-6">
            <IconBox
              icon='/images/icons/tour-icon.svg'
              title='Tourism & Hospitality'
              subtitle='Virtual destination previews, hotel tours, and experience marketing.'
            />
          </Div>
        </Div>
      </Div>

      <Spacing lg='150' md='80' />
    </>
  )
}
